import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api';
import { addParamsToUrl } from 'utils';

import { apiQuery } from '../../query';

import {
  ReferenceItem,
  SearchReferenceItemsRequest,
  SearchReferenceItemsResponse,
} from './types';

export const referenceItemsApi = createApi({
  baseQuery: apiQuery,
  reducerPath: 'referenceItemsApi',
  endpoints: (build) => ({
    search: build.query<ReferenceItem[], SearchReferenceItemsRequest>({
      transformResponse: (response: SearchReferenceItemsResponse) =>
        response.data,
      query: ({ formId, fieldId, ...params }) => ({
        method: 'get',
        url: addParamsToUrl(
          URL.REFERENCE_ITEMS_SEARCH.replace(':formId', formId).replace(
            ':fieldId',
            fieldId
          ),
          params
        ),
      }),
    }),
  }),
});

export const { useLazySearchQuery } = referenceItemsApi;
